import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import ApiService from '@/services/ApiService';

import { Application } from '@/models/ApplicationsModels';

export const useApplicationsStore: any = defineStore('applicationsStore', () => {
  const commonStore = useCommonStore();

  const applications = ref<Application[]>(sessionStorage.getItem('applications') != null ? JSON.parse(sessionStorage.applications) : []);

  //#region Application
  async function getApplications() {
    commonStore.setStatus({ ...commonStore.status, getApplicationLoading: true, applicationErrorMsg: '' });

    return ApiService.getAllApplications()
      .then((res) => {
        const data: Application[] = res.data;

        applications.value = data;
        sessionStorage.setItem('applications', JSON.stringify(applications.value));
      })
      .catch((err) => {
        commonStore.status.applicationErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.getApplicationLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  async function createApplication(data: Application) {
    commonStore.setStatus({ ...commonStore.status, createApplicationLoading: true, applicationErrorMsg: '' });

    return ApiService.createApplication(data)
      .then((res) => {
        const data: Application = res.data;

        applications.value.push(data);
        sessionStorage.setItem('applications', JSON.stringify(applications.value));
      })
      .catch((err) => {
        commonStore.status.applicationErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.createApplicationLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  async function updateApplication(data: Application) {
    commonStore.setStatus({ ...commonStore.status, updateApplicationLoading: true, applicationErrorMsg: '' });

    return ApiService.updateApplication(data)
      .then((res) => {
        const data: Application = res.data;

        var index = applications.value.findIndex((mapping) => mapping.id === data.id);
        if (index !== -1) {
          applications.value.splice(index, 1, data);
        } else {
          applications.value.push(data);
        }

        sessionStorage.setItem('applications', JSON.stringify(applications.value));
      })
      .catch((err) => {
        console.error(err);
        commonStore.status.applicationErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.updateApplicationLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  async function deleteApplication(id: number) {
    commonStore.setStatus({ ...commonStore.status, deleteApplicationLoading: true, applicationErrorMsg: '' });

    return ApiService.deleteApplication(id)
      .then(() => {
        applications.value = applications.value.filter((mapping) => mapping.id !== id);
        sessionStorage.setItem('applications', JSON.stringify(applications.value));
      })
      .catch((err) => {
        console.error(err);
        commonStore.status.applicationErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.deleteApplicationLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }
  //#endregion

  return {
    applications,

    getApplications,
    createApplication,
    updateApplication,
    deleteApplication,
  };
});
